import { LoadingParagraph } from '@zg-rentals/loading-components';
import { Paragraph } from '@zillow/constellation-10';

import { StyledCard, StyledIconChevronRightCircle, StyledLabel } from './StyledComponents';

type Props = {
  onClick: () => void;
  label: string;
  count?: number;
  isLoading?: boolean;
};

const InquiryCountCard = ({ onClick, count, label, isLoading }: Props) => {
  return (
    <StyledCard onClick={onClick} cardType="secondary" cardElevation={0}>
      <StyledLabel display="flex">
        {typeof count === 'number' && (
          <LoadingParagraph
            data-testid="unread-value"
            textStyle="body-sm-bold"
            isLoading={Boolean(isLoading)}
            loadingWidth="50%"
          >
            {count}&nbsp;
          </LoadingParagraph>
        )}
        <Paragraph textStyle="body-sm" data-testid="unread-text">
          {label}
        </Paragraph>
      </StyledLabel>
      <StyledIconChevronRightCircle size="sm" />
    </StyledCard>
  );
};

export default InquiryCountCard;
